module.exports = __webpack_public_path__ + "assets/img/e06e-va.svg";